import {Chip} from '@mui/material';
import React, {FC} from 'react';

interface BooleanValueProps {
  value: boolean;
  yesLabel: string;
  noLabel: string;
}

/**
 * Composant pour afficher une valeur booléenne
 */
export const BooleanValue: FC<BooleanValueProps> = ({value, yesLabel, noLabel}) => {
  return (
    <Chip
      label={value ? yesLabel : noLabel}
      size="small"
      color={value ? 'success' : 'error'}
      variant={value ? 'filled' : 'outlined'}
    />
  );
};
